module.exports = vendors_3dab5feb05d04215c9a2;